export const ADD_SCHOOL_ATTENDED_STARTED =
  'ADD_SCHOOL_ATTENDED_STARTED';
export const ADD_SCHOOL_ATTENDED_SUCCESS =
  'ADD_SCHOOL_ATTENDED_SUCCESS';
export const ADD_SCHOOL_ATTENDED_ENDED = 'ADD_SCHOOL_ATTENDED_ENDED';
export const ADD_SCHOOL_ATTENDED_ERROR = 'ADD_SCHOOL_ATTENDED_ERROR';
